import {Grid, Loader} from '@logistics-frontend/blocks'
import React from 'react'
import {useParams} from 'react-router-dom'

import {CitiesColumn} from './components/cities-column'
import {TariffsWithDetails} from './components/tariffs-with-details'
import {useTariffZones} from './hooks'
import {TariffsPageParams, TariffsProps} from './types'

const Tariffs: React.FC<TariffsProps> = ({
  fetchTariffs,
  fetchZones,
  isPostPaymentEnabled,
  surgeLink,
  disclaimerKey,
  urls,
  defaultCountry,
  defaultZone,
}) => {
  const {zone, country} = useParams<TariffsPageParams>()

  const {isZonesPending, tariffZones} = useTariffZones(fetchZones)

  return (
    <Grid spacing={4} container>
      <Grid data-e2e="country-tariffs" xs={3} item>
        {isZonesPending ? (
          <Loader />
        ) : (
          <CitiesColumn
            defaultCountry={defaultCountry}
            defaultZone={defaultZone}
            tariffZones={tariffZones}
            urls={urls}
          />
        )}
      </Grid>
      <TariffsWithDetails
        key={`${country}/${zone}`}
        disclaimerKey={disclaimerKey}
        fetchTariffs={fetchTariffs}
        isPostPaymentEnabled={isPostPaymentEnabled}
        surgeLink={surgeLink}
        tariffZones={tariffZones}
        urls={urls}
      />
    </Grid>
  )
}

export default Tariffs
